<template>
  <div>
    <div class="content" :style="styleObj" v-if="triggerAnimation">
      <div v-for="(item, index) in 200" :key="index" class="snow"></div>
    </div>
  </div>
</template>

<script>
import EventBus from '../router/event-bus.js'

export default {
  name: 'VabSnow',
  props: {
    styleObj: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  mounted () {
    EventBus.$on('animationEvent', this.handleAnimation)
  },
  beforeDestroy () {
    EventBus.$off('animationEvent', this.handleAnimation)
  },
  data () {
    return {
      triggerAnimation: true,
    }
  },
  created () {
    let that = this
    this.$watch(() => this.$route, (to, from) => {
      that.handleAnimation()
    })
  },
  methods: {
    handleAnimation () {
      this.triggerAnimation = false
      this.$nextTick(() => {
        this.triggerAnimation = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
  background: transparent;
  z-index: 9999;
  filter: drop-shadow(0 0 10px white);
  animation: fadeOut 30s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@function random_range($min, $max) {
  $rand: random();
  $random_range: $min + floor($rand * (($max - $min) + 1));

  @return $random_range;
}

.snow {
  $total: 200;
  position: absolute;

  @for $i from 1 through $total {
    $random-x: random(1000000) * 0.0001vw;
    $random-offset: random_range(-100000, 100000) * 0.0001vw;
    $random-x-end: $random-x + $random-offset;
    $random-x-end-yoyo: $random-x + ($random-offset / 2);
    $random-yoyo-time: random_range(30000, 80000) / 100000;
    $random-yoyo-y: $random-yoyo-time * 100vh;
    $random-scale: random(10000) * 0.0001;
    $fall-duration: random_range(10, 30) * 0.8s;
    $fall-delay: random(30) * -1s;

    &:nth-child(#{$i}) {
      opacity: random(100) * 0.02;
      transform: translate($random-x, -10px) scale($random-scale);
      position: relative;
      font-size: 0; // 设置字体大小为0，以隐藏文本内容
      color: transparent; // 设置颜色为透明
      animation: fall-#{$i} $fall-duration $fall-delay linear infinite;

      &::before {
        content: "❄";
        position: absolute;
        font-size: 22px; // 设置合适的字体大小
        color: white; // 设置颜色
      }
    }

    @keyframes fall-#{$i} {
      #{percentage($random-yoyo-time)} {
        transform: translate($random-x-end, $random-yoyo-y) scale($random-scale);
      }

      to {
        transform: translate($random-x-end-yoyo, 100vh) scale($random-scale);
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/VabSnow.vue